import { render, staticRenderFns } from "./ChristmasGarland2.vue?vue&type=template&id=750a5c01&scoped=true"
import script from "./ChristmasGarland2.vue?vue&type=script&lang=js"
export * from "./ChristmasGarland2.vue?vue&type=script&lang=js"
import style0 from "./ChristmasGarland2.vue?vue&type=style&index=0&id=750a5c01&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750a5c01",
  null
  
)

export default component.exports